import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const BannerReserved = styled.div``;

export const Content = styled.main`
	display: flex;
	width: 100vw;
	max-width: 1680px;
	height: 100%;
	flex-flow: column nowrap;
	flex-grow: 1;
	align-items: stretch;
	padding-top: var(--safe-top);
	padding-bottom: calc(1.6rem + var(--safe-bottom));
	margin: unset;
	${MqTablet} {
		margin: 0 auto;
	}
	& > .loader {
		margin: auto;
	}

	&:has(.fullpage-layout) {
		overflow: auto;
		height: 100svh;
		padding-top: calc(var(--header-height));
		margin-top: calc(-1 * (var(--header-height) - var(--safe-top)));
	}
`;
